import { SpinnerCircularFixed } from 'spinners-react';

const Spinner = () => {
  return (
    <SpinnerCircularFixed size={60} thickness={200} speed={130} color='#2683ed' secondaryColor='rgba( 0,0,0, 0.2)' />
  );
};

export default Spinner;
